module.exports = __webpack_public_path__ + "img/envelope-3.e9d96963.svg";